<div class="popup-overlay">
    <div class="popup-carousel">
      <img [src]="images[currentIndex]" alt="Image" class="popup-image" />
  
      <button (click)="prev()"><</button>
      <button (click)="next()">></button>

      <div class="dots-container">
        <span *ngFor="let img of images; let i = index" class="dot" [class.active]="i === currentIndex" (click)="selectSlide(i)">
        </span>
      </div>
      
    </div>
  </div>